import React, { useEffect, useRef } from "react";
import payrollDates from "./payrollDates";

const findClosestPeriodIndex = () => {
  const currentDate = new Date();
  let closestIndex = 0;
  let minDiff = Number.MAX_VALUE;

  payrollDates.forEach((period, index) => {
    const [startDateString, endDateString] = period.includeDates.split("-");
    const startDate = new Date(`${startDateString}`);
    const endDate = new Date(`${endDateString}`);

    if (currentDate >= startDate && currentDate <= endDate) {
      closestIndex = index;
      minDiff = 0;
    } else {
      const diff = Math.min(
        Math.abs(currentDate - startDate),
        Math.abs(currentDate - endDate)
      );
      if (diff < minDiff) {
        closestIndex = index;
        minDiff = diff;
      }
    }
  });

  return closestIndex;
};

const closestPeriodIndex = findClosestPeriodIndex();

export default function PayrollScheduleTable() {
  const rowRefs = useRef([]);

  useEffect(() => {
    if (rowRefs.current[closestPeriodIndex]) {
      rowRefs.current[closestPeriodIndex].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, []);

  return (
    <div className="w-full space-y-3">
      <div className="border-b border-gray-200 pb-3">
        <div className="flex items-baseline justify-between">
          <h1 className="text-base font-semibold text-gray-900">
            Payroll Schedule
          </h1>
          {/* <span className="text-xs text-gray-500">
            {new Date().toLocaleDateString()}
          </span> */}
        </div>
        <p className="text-xs text-gray-500 mt-1">
          A list of all payroll periods including their end date, included appointment dates, submission date, and payment date.
        </p>
      </div>

      <div className="border border-gray-200">
        <div className="max-h-[32rem] overflow-y-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-gray-200 bg-gray-100/80">
                <th scope="col" className="h-8 px-3 text-left text-xs font-medium text-gray-500 sticky top-0 bg-gray-100/80 first:border-l-0 last:border-r-0">
                  Pay Period
                </th>
                <th scope="col" className="h-8 px-3 text-left text-xs font-medium text-gray-500 sticky top-0 bg-gray-100/80 first:border-l-0 last:border-r-0">
                  Pay Period Ending Date
                </th>
                <th scope="col" className="h-8 px-3 text-left text-xs font-medium text-gray-500 sticky top-0 bg-gray-100/80 first:border-l-0 last:border-r-0">
                  Include Dates
                </th>
                <th scope="col" className="h-8 px-3 text-left text-xs font-medium text-gray-500 sticky top-0 bg-gray-100/80 first:border-l-0 last:border-r-0">
                  Submission Date
                </th>
                <th scope="col" className="h-8 px-3 text-left text-xs font-medium text-gray-500 sticky top-0 bg-gray-100/80 first:border-l-0 last:border-r-0">
                  Payment Date
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {payrollDates.map((period, index) => {
                const isClosest = index === closestPeriodIndex;
                const isBeforeClosest = index < closestPeriodIndex;
                return (
                  <tr
                    key={period.payPeriodNumber}
                    ref={(el) => (rowRefs.current[index] = el)}
                    className={`
                      transition-colors
                      ${isClosest ? "bg-indigo-50 hover:bg-indigo-100" : 
                        isBeforeClosest ? "bg-gray-50/50 text-gray-400" : 
                        "bg-white hover:bg-gray-50/50"}
                    `}>
                    <td className="h-9 px-3 text-xs font-medium">
                      {period.payPeriodNumber}
                    </td>
                    <td className="h-9 px-3 text-xs">
                      {period.payPeriodEndingDate}
                    </td>
                    <td className="h-9 px-3 text-xs">
                      {period.includeDates}
                    </td>
                    <td className="h-9 px-3 text-xs">
                      {period.submissionDate}
                    </td>
                    <td className="h-9 px-3 text-xs">
                      {period.paymentDate}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
